// extracted by mini-css-extract-plugin
module.exports = {"default":"ButtonPrimary_default__KNYyu","inverse":"ButtonPrimary_inverse__3rYtC","fullWidth":"ButtonPrimary_fullWidth__Q_WxX","disabled":"ButtonPrimary_disabled__B_VQt"};